"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAY = void 0;
exports.DAY = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:DAY not implemented');
    },
};
//# sourceMappingURL=day.js.map